/*
  HU06 Preventa -- "Picking Global Preventa" (TASKID 242, flowBolCI09).

  Resuelve el gap documentado en docs/picking-preventa-form-design.md:
  reusar FRMPG (Picking Global real, externalForm04.js) tal cual dejaba
  esta tarea SIN el validador de fecha+SAP que tenia la vieja "Picking
  Preventa"(234). Este form SI es nuevo (no un reuso 1:1) -- muestra el
  mismo tipo de resumen que Picking Global (items del pedido, acá
  siempre en preventa) pero bloquea el avance hasta que
  /api/preventa/checkDisponibilidad (manageIntegrations, que a su vez
  invoca manageOrdenes) confirme que la fecha de cierre ya paso Y el
  stock real ya esta cargado (SAP).
*/
import React from "react";
import {
  MDBContainer,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBAlert,
  toast,
  ToastContainer,
} from "mdbreact";
import { XBtn } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG } from "../../Config/config-env.js";
import axios from "axios";
import { applyExternalDarkMode } from "../../Config/functions";
import LockOverlay from "../../Components/LockOverlay";

class externalForm12 extends React.Component {
  state = {
    loadingData: true,
    isExecuting: false,
    locked: false,
    token: "",
    WO_Id: "",
    WO_TaskId: "",
    optionValue: "Picking completado",
    order_id: "",
    disponible: false,
    checkMessage: "",
    items: [],
  };

  componentDidMount = async () => {
    await this.LoadTask();
  };

  LoadTask = async () => {
    const params = new URLSearchParams(this.props.location.search);
    applyExternalDarkMode(this.props.location.search);
    const token = params.get("token");
    const WO_Id = params.get("wfpflowid");
    const WO_TaskId = params.get("wfptaskid");
    const locked = params.get("locked") === "true";
    // La tarea siempre manda sus opciones validas por query string (mismo
    // patron que externalForm04.js) -- usar la real en vez de un string fijo
    // evita que se desincronice si la transicion del flujo cambia (paso lo
    // mismo con TASKID 234: su transicion esperaba "Preventa Lista" pero el
    // form mandaba "Picking completado" hardcodeado, y el flujo quedaba sin
    // avanzar sin ningun error visible).
    const options = (params.get("options") || "").split(",").filter(Boolean);
    const optionValue = options[0] || this.state.optionValue;

    this.setState({ loadingData: true, token, WO_Id, WO_TaskId, locked, optionValue });

    const taskDetails = await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      data: { wfptaskid: WO_TaskId },
      method: "post",
    }).then((r) => r.data);

    let order_id = "";
    for (const v in taskDetails.flowvars || []) {
      if (taskDetails.flowvars[v].VARNAME === "order_id") order_id = taskDetails.flowvars[v].VARVALUE;
    }

    this.setState({ order_id }, this.checkDisponibilidad);
  };

  checkDisponibilidad = async () => {
    this.setState({ isExecuting: true });
    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id: this.state.order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .catch(() => ({ status: false, message: "No se pudo validar disponibilidad" }));

    this.setState({
      loadingData: false,
      isExecuting: false,
      disponible: !!resp.disponible,
      checkMessage: resp.message || "",
      items: resp.items || [],
    });
  };

  executeTask = async () => {
    if (this.state.locked || !this.state.disponible) return;
    this.setState({ isExecuting: true });

    await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      url: API_CONFIG.xflowurl + "/engine-users/execute-task",
      data: {
        parentid: this.state.WO_TaskId,
        id: this.state.WO_TaskId,
        optionValue: this.state.optionValue,
        params: {},
      },
      method: "put",
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.status) {
          toast.success("Procesado con éxito", { closeButton: true });
          setTimeout(() => window.parent.postMessage("TAREA_COMPLETADA", "*"), 1000);
        } else {
          toast.error("Error ejecutando la tarea: " + data.message, { closeButton: true });
        }
        this.setState({ isExecuting: false });
      });
  };

  render() {
    const { loadingData, disponible, items, checkMessage } = this.state;
    return (
      <>
        <MDBContainer className="xext-page xext-form12">
          <LockOverlay visible={this.state.locked && !loadingData} />
          {loadingData ? (
            <Loader idLoading={loadingData} />
          ) : (
            <>
              <Loader idLoading={this.state.isExecuting} />
              <MDBCard className="mb-3">
                <MDBCardHeader>Picking Global Preventa — Pedido #{this.state.order_id}</MDBCardHeader>
                <MDBCardBody>
                  {disponible ? (
                    <MDBAlert color="success">
                      <MDBIcon icon="check-circle" /> Todos los items de preventa ya llegaron (fecha
                      cerrada + stock cargado en SAP). Se puede continuar al picking.
                    </MDBAlert>
                  ) : (
                    <MDBAlert color="warning">
                      <MDBIcon icon="lock" /> Todavía no se puede pickear este pedido — {checkMessage || "hay items en preventa pendientes"}.
                    </MDBAlert>
                  )}

                  {items.map((it) => (
                    <MDBRow key={it.item_id} className="py-2 border-bottom">
                      <MDBCol md="4">{it.sku}</MDBCol>
                      <MDBCol md="3">Cantidad: {it.cantidad}</MDBCol>
                      <MDBCol md="3">
                        Cierre preventa: {it.fecha_fin ? new Date(it.fecha_fin).toLocaleDateString() : "-"}
                      </MDBCol>
                      <MDBCol md="2">
                        {it.disponible ? (
                          <MDBIcon icon="check" className="green-text" />
                        ) : (
                          <MDBIcon icon="clock" className="orange-text" />
                        )}
                        {" "}Stock real: {it.stock_real}
                      </MDBCol>
                    </MDBRow>
                  ))}

                  <MDBRow className="mt-4">
                    <MDBCol md="6">
                      <XBtn size="sm" outline onClick={this.checkDisponibilidad} disabled={this.state.isExecuting}>
                        <MDBIcon icon="sync" /> Revalidar
                      </XBtn>
                    </MDBCol>
                    <MDBCol md="6" className="text-right">
                      <XBtn
                        color="success"
                        onClick={this.executeTask}
                        disabled={!disponible || this.state.isExecuting}
                      >
                        Picking completado
                      </XBtn>
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </>
          )}
        </MDBContainer>
        <ToastContainer hideprogress_Bar={true} newestOnTop={false} />
      </>
    );
  }
}

export default externalForm12;
